export const getIsOrangeComboButtonEnabled = () =>
  !!window?.abTestChoices?.elkOrangeComboButtonEnabled;
